import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { checkPhoneNumberExpired, phoneNumberCaptureSubmit } from '../../../actionCreators/phoneNumberCapture';
import localStorageHelper from '../../../utils/localStorageHelper';
import { isMobile } from '../../../utils/validation';
import LKModal from '../Modal/Modal';
import './phoneNumberCapturePopUp.scss';

function PhoneNumberCapturePopUp(props) {
    const { login, redisCommonData, hasCookieExpired, numberSubmitting, dataLocale, localeInfo, handleClose, page, showPhnCapture, phoneNumberCaptureSubmit, checkPhoneNumberExpired, userInfo } = props;
    const { PHONE_NUMBER_CAPTURE_CONFIG_NEW_DESKTOP, AVAILABLE_NEIGHBOUR_COUNTRIES } = redisCommonData;
    const { ENTER_NUMBER_TO_UNLOCK_OFFER,
        CONTINUE,
        YOUR_PHONE_NUMBER,
        SYMBOL_ASTRIX,
        WE_WILL_NOT_SHARE_NUMBER_WITH_ANYONE,
        PHONE_CODE, } = dataLocale;
    const [phoneNumber, setPhoneNumber] = useState('');
    const [errorPhoneNumber, setErrorPhoneNumber] = useState('');
    const [showPopUpAfter5Sec, setShowPopUpAfter5Sec] = useState(false);
    const isRepeat = userInfo?.hasPlacedOrder;
    const countryConfig = AVAILABLE_NEIGHBOUR_COUNTRIES
        ? JSON.parse(AVAILABLE_NEIGHBOUR_COUNTRIES)
        : {};
    let phoneCaptureData = {};
    if (typeof PHONE_NUMBER_CAPTURE_CONFIG_NEW_DESKTOP !== 'undefined' && PHONE_NUMBER_CAPTURE_CONFIG_NEW_DESKTOP) {
        const captureNumberNewconfig = JSON.parse(PHONE_NUMBER_CAPTURE_CONFIG_NEW_DESKTOP);
        phoneCaptureData = captureNumberNewconfig[page];
    }
    const { countryCode } = localeInfo;
    const postPhoneNumber = () => {
        if (isMobile(phoneNumber, { countryCode })) {
            setErrorPhoneNumber('Please enter a valid Mobile Number');
        } else {
            submitMobileNumber(phoneNumber);
        }
    };

    function submitMobileNumber(phone) {
        const { NEW_CAPTURE_NUMBER_EXPIRY } = redisCommonData;
        const phNo = phone;
        const jsonData = {
            collectionData: [
                {
                    phone: phNo,
                    created_at: new Date(),
                    UTM: window.location.search,
                    device_id: 'mobile',
                    platform: 'mobilesite',
                    is_verified: 0,
                    version: "4.7.0",
                    phoneCode: localeInfo.phoneCode
                },
            ],
        };
        const data = { jsonData, phNo, NEW_CAPTURE_NUMBER_EXPIRY };
        phoneNumberCaptureSubmit(data);
        handleClose();
        localStorageHelper.setItem('repeatFlowPhoneCapture', 'true');
        setShowPopUpAfter5Sec(false);
    }

    const checkLoginRepeat = () => {
        if (login && !isRepeat) {
            return true;
        } else if (login && isRepeat) {
            return false;
        } else if (!login) {
            return true;
        }
    };

    useEffect(() => {
        if (hasCookieExpired === null) {
            checkPhoneNumberExpired();
        }
        setTimeout(() => {
            setShowPopUpAfter5Sec(true);
        }, 5000)
    }, [])

    const handleModalClose = () => {
        handleClose();
        localStorageHelper.setItem('repeatFlowPhoneCapture', 'true');
        setShowPopUpAfter5Sec(false);
    }

    return (
        <div>
            {checkLoginRepeat() && hasCookieExpired && showPopUpAfter5Sec && showPhnCapture && <LKModal
                backdrop
                keyboard
                showModal={showPhnCapture}
                size="large"
                hideHandler={handleModalClose}
            >
                <div className="desktop-capture-modal">
                    <span
                        className="desktop-capture-close text-right"
                        // onClick={handleClose}
                        onClick={handleModalClose}
                    >
                        &#10005;
                    </span>
                    <div className="desktop-capture-modal-content-wrapper">
                    <div className="cat-mobile-capture-text fw-700 fsp16 mr-t10 pd-l30 pd-r30">
                        <div style={{ color: '#00B0BF' }}>
                            {phoneCaptureData.headerText.split(' ').slice(0, 2).join(' ') || ENTER_NUMBER_TO_UNLOCK_OFFER}
                        </div>
                        <div>
                            {phoneCaptureData.headerText.split(' ').slice(2).join(' ')}
                        </div>
                    </div>

                    <div className="capture-phone">
                        <div className="phnnumberWrapper mr-t30 mr-b10">
                            {countryConfig.availableCountries &&
                                countryConfig.availableCountries.length > 0 ? (
                                <select
                                    className="uae-width country-code inline-block fsp20 country-code-m-display text-cool_grey"
                                    name="countryCodes"
                                >
                                    {countryConfig.availableCountries?.map(cc => (
                                        <option value={cc.code}>{cc.code}</option>
                                    ))}
                                </select>
                            ) : (
                                <div className="country-code">{PHONE_CODE}</div>
                            )}
                            <div>
                                <input
                                    autoComplete="phone"
                                    className={`${countryCode}-input-padding input-signup-mobile`}
                                    maxLength={localeInfo.maxMobileNumberLength}
                                    minLength={localeInfo.minMobileNumberLength}
                                    name="phone"
                                    placeholder={
                                        `${phoneCaptureData.inputLabel} ${SYMBOL_ASTRIX}` ||
                                        `${YOUR_PHONE_NUMBER} ${SYMBOL_ASTRIX}`
                                    }
                                    type="tel"
                                    value={phoneNumber}
                                    onChange={e => {
                                        setPhoneNumber(e.target.value);
                                        setErrorPhoneNumber('');
                                    }}
                                />
                            </div>
                        </div>
                        {errorPhoneNumber && (
                            <div
                                className="text-color_brick_red"
                                style={{ marginBottom: '5px', color: 'rgb(243 15 15)' }}
                            >
                                {errorPhoneNumber}
                            </div>
                        )}

                        <button
                            className="btn-phone-capture new-btn fsp16 text-color_white"
                            type="submit"
                            onClick={postPhoneNumber}
                        >
                            {numberSubmitting ? (
                                <span className="pd-t5 pd-b5 block icon-spinner animate-spin"></span>
                            ) : (
                                <span className="pd-t5 pd-b5 block">
                                    {phoneCaptureData.buttonTxt || CONTINUE}
                                </span>
                            )}
                        </button>
                    </div>
                    <div className="terms-condition">
                        <p className="fsp10 terms-condition-text" >
                            {phoneCaptureData.subHeadingText || WE_WILL_NOT_SHARE_NUMBER_WITH_ANYONE}
                        </p>
                    </div>
                    </div>
                </div>
            </LKModal>}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        login: state.common.login,
        redisCommonData: state.common.redisCommonData,
        hasCookieExpired: state.phoneNumberCapture.hasCookieExpired,
        numberSubmitting: state.phoneNumberCapture.numberSubmitting,
        numberSubmitted: state.phoneNumberCapture.numberSubmitted,
        dataLocale: state.locale,
        localeInfo: state.common.localeInfo,
        userInfo: (state.common.userInfo && state.common.userInfo.result) || null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        checkPhoneNumberExpired: () => dispatch(checkPhoneNumberExpired()),
        phoneNumberCaptureSubmit: data => dispatch(phoneNumberCaptureSubmit(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneNumberCapturePopUp);